<template>
	<v-dialog v-model="dialog" persistent max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>{{'modify channel' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Modify the parameters of the channel' | localize}} <span class="secondary--text">{{ name }}</span>
			</v-card-title>
			<v-divider />
			<v-card-text class="black--text">
				<v-container grid-list-md>
					<v-form v-model="valid" ref="form" lazy-validation>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-select dense
									v-model="trademark"
									:items="teamTrademarks"
									item-text="name"
									item-value="name"
									multiple
									color="secondary"
									item-color="secondary"
									:label="'Trademarks' | localize"
									@change="onceMore"
									:rules="[rules.required]">
								</v-select>
							</v-col>
							<v-col cols="12" sm="3" md="3">
								<v-text-field
									color="secondary"
									:label="'Stores' | localize"
									v-model.number="stores"
									name="stores"
									type="text"
									:rules="[rules.number]"
									:readonly="readonly"
									@change="onceMore()"
									>
								</v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<v-row v-if="error" class="text-center mx-2 error--text">{{'Error' | localize }} => {{ error }} &#129488;</v-row>
				<v-row class="text-start text-pre-wrap mx-2">{{ message }}</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!valid || calculating"
					@click="calculate">
					{{'Calculate' | localize}}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!calculating || Boolean(error)"
					@click="changeChannel">
					{{'Save' | localize}}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" 
					@click="closeDialog">
					{{'Close' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

import { retailInvestments, operationalCosts } from '../../../functions/retail';
import { localeNumber } from '../../../functions/common.js';
import localizeFilter from '../../../filters/localize.filter.js';

export default {
	props: ['channel'],
	data () {
		return	{
			dialog: false,
			valid: false,
			message: '',
			error: '',
			calculating: false,
			rules: {
				required: v => (v && v.length > 0) || localizeFilter('required field'),
				number: v => {
					if (!isNaN(parseFloat(v)) && v >= 1 && v <= 999) return true;
					return localizeFilter('its expected number between 1 and 999');
				}
			},
			stores: this.channel.stores,
			trademark: this.channel.trademarks,
			name: this.channel.name,

			operational: 0,
			investments: 0,
			toAdd: [], /* trademarks to add  */
			toRemove: [], /* trademarks to remove */
		}
	},
	computed: {
		loading () {
			return this.$store.getters.loading;
		},
		locale() {
			return this.$store.getters.locale;
		},
		readonly () {
			if (this.channel.type == 1) return true
			return false
		},
		trademarks() {
			return this.$store.getters.trademarks;
		},
		intermediary() {
			return this.$store.getters.intermediary;
		},
		team() {
			return this.$store.getters.team;
		},
		teamTrademarks() {
			let res = [];
			if (this.team) {
				const arr = [];
				this.team?.products.map(prod => {
					const inArr = arr.find(it => it === prod.trademarkId)
					if (!inArr) {
						arr.push(prod.trademarkId)
					}
				})
				res = this.trademarks?.filter(it => arr.indexOf(it.id) !== -1)
			}
			return res
		},
	},
	methods: {
		calculate () {
			if (this.$refs.form.validate()) {
					
				if (this.stores === this.channel.stores && this.trademark.length == this.channel.trademarks.length) {
					return this.error = localizeFilter('no parameters have been changed');
				}

				//aditional stores
				const delta = this.stores - this.channel.stores;
				

				if (delta > 0) {
					//added investments & calculate the operational cost
					this.investments = retailInvestments(this.channel.type, delta);
					this.operational = operationalCosts(this.channel.type, this.stores);						
					
					/* locale - massages*/
					if (this.locale == 'ro-RO') {
						this.message = `Vă rugăm să luați notă de cifre:

						Costurile de investiție = $${localeNumber(this.investments, this.locale)}
						Costuri operaționale = $${localeNumber(this.operational, this.locale)}
						--------------------------------------------------------------
					Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
					} 
					else if (this.locale == 'ru-RU') {
						this.message = `Пожалуйста, обратите внимание на цифры:

						Инвестиции = $${localeNumber(this.investments, this.locale)}
						Операционные расходы = $${localeNumber(this.operational, this.locale)}
						-------------------------------------------------------
					Согласны? Нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
					}
					else {
						this.message = `Please take note of the figures:

						Investment costs = $${localeNumber(this.investments, this.locale)}
						Operational costs = $${localeNumber(this.operational, this.locale)}
						---------------------------------------------------------
					If you agree, press the button "Save", else - press "Close"`
					}
						
				}
				else if (delta < 0) {
					//not add investments, but decrease operational costs
					this.operational = operationalCosts(this.channel.type, this.stores);
					
					/* locale - massages*/
					if (this.locale == 'ro-RO') {
						this.message = `Vă rugăm să luați notă:

						Costuri operaționale = $${localeNumber(this.operational, this.locale)}
						--------------------------------------------------------------
					Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
					} 
					else if (this.locale == 'ru-RU') {
						this.message = `Пожалуйста, обратите внимание:

						Операционные расходы = $${localeNumber(this.operational, this.locale)}
						-------------------------------------------------------
					Согласны? Нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
					}
					else {
						this.message = `Please take note:

						Operational costs = $${localeNumber(this.operational, this.locale)}
						---------------------------------------------------------
					If you agree, press the button "Save", else - press "Close"`
					}
				}
					
				if (!this.error && delta == 0) {
					const trademarksList = this.trademark;
					const trademarksChan = this.channel.trademarks;

					if (trademarksList?.length > trademarksChan?.length) {
						//add trademark(s) to channel
						trademarksList.forEach(item => {
							const inChannel = trademarksChan?.find(tr => tr.name == item)
							if (!inChannel) {
								this.toAdd.push(item)
							}
						})
						//console.log(this.toAdd)
						const trs = this.toAdd.join(' ');

						/* locale - massages*/
						if (this.locale == 'ro-RO') {
							this.message = `Dacă doriți să adăugați mărc(i) comerciale: ${trs}, 
							apăsați butonul "Salvare", altfel - apăsați "Închide"`
						} 
						else if (this.locale == 'ru-RU') {
							this.message = `Если хотите добавить торговые марки: ${trs},  
							нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
						}
						else {
							this.message = `If you want to add trademark(s): ${trs},
							press the button "Save", else - press "Close"`
						}
						
					}
					else {
						//remove trademark(s) from the channel
						trademarksChan?.forEach(item => {
							const inChannel = trademarksList?.find(tr => tr == item.name)
							if (!inChannel) {
								this.toRemove.push(item.name)
							}
						})
						const trs = this.toRemove.join(', ');

						/* locale - massages*/
						if (this.locale == 'ro-RO') {
							this.message = `Dacă doriți să ștergeți mărcile comerciale: ${trs} de pe canal, 
							apăsați butonul "Salvare", altfel - apăsați "Închide"`
						} 
						else if (this.locale == 'ru-RU') {
							this.message = `Если хотите удалить торговые марки: ${trs}, из канала,  
							нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
						}
						else {
							this.message = `If you want to remove trademark(s): ${trs},from the channel,
							press the button "Save", else - press "Close"`
						}
					}
					
				}
				this.calculating = true;				
			}	
		},
		onceMore () {
			this.error = ''
			this.message = ''			
			this.calculating = false;
			this.valid = true;
		},
		async changeChannel () {

			if (this.stores !== this.channel.stores) {
				
				/* reduction in the number of stores ? => retail_writte_off */
				if (this.stores < this.channel.stores) {
					
					if (this.channel.round !== this.channel.register_round) {
						//update intermediaries 
						const delta = this.channel.stores - this.stores;
						const retail_writte_off = retailInvestments(this.channel.type, delta);

						if (!this.intermediary) {
							return this.error = 'Not find the intermediary';
						}

						const obj = {
							id: this.intermediary?.id,
							retail_writte_off: this.intermediary?.retail_writte_off + retail_writte_off,
						}

						/* console.log(obj)*/
						try {
							await this.$store.dispatch('updateIntermediary', obj);
						}
						catch(error) {
							this.error = `Updating intermediary error: ${error.message}`;
						} 
					}
				}
				
				const channel = {
					id: this.channel.id,
					stores: this.stores,
					investment_costs: this.channel.investment_costs + this.investments,
					operational_costs: this.operational,
				}
				/*console.log(`channel investments: ${this.channel.investment_costs}`)
				console.log(`added investments: ${this.investments}`)
				console.log(`new investments: ${channel.investment_costs}`)*/
				try {
					await this.$store.dispatch('editChannel', channel);
				} catch(error) {
                    this.error = `Updating channel error: ${error.message}`;
                }
			}
				
			if (this.toRemove.length > 0) {
				//if trademark include special signs like as $, %, + ...  => encodeURIComponent()
				this.toRemove?.forEach(async(trademark) => {
					//console.log(encodeURIComponent(trademark))
					this.removeTrademark(encodeURIComponent(trademark))
				});

			}
			else if (this.toAdd?.length > 0) {
				this.toAdd?.forEach(trademark => {
					this.addTrademarktoChannel(trademark)
				})
			}
			this.closeDialog ()				
				
		},
		async addTrademarktoChannel(trademark) {
			const obj = {
				channelId: this.channel.id,
				trademark: trademark
			}
			await this.$store.dispatch('addTrademarkToChannel', obj);
		},
		async removeTrademark(trademark) {
			const obj = {
				channelId: this.channel.id,
				trademark: trademark
			}
			await this.$store.dispatch('removeTrademarkFromChannel', obj);
		},
		closeDialog () {
			//reset
			this.dialog = false
			this.error = ''
			this.message = ''
			this.calculating = false
			
			this.stores = this.channel.stores;
			this.trademark = this.channel.trademarks;
			this.delta = 0;

			this.operational = 0;
			this.investments = 0;
			this.toAdd = []; /* trademarks to add  */
			this.toRemove = []; /* trademarks to remove */
		}
	},
}
</script>